<template>
    <v-container :fluid="$vuetify.breakpoint.md">
        <v-stepper v-model="section" vertical elevation="0">
            <v-form ref="form" @submit.prevent="submit" lazy-validation v-model="valid">
                <v-stepper-step :complete="section > 1" step="1">
                    Calcule su Envío
                    <small>Puede modificar el valor depositado o el valor en destino</small>
                </v-stepper-step>

                <v-stepper-content step="1">
                    <v-card elevation="0" class="pb-3">
                        <v-row justify="center">
                            <v-col cols="12" class="pt-0 pb-2">
                                <h3 class="text-center grey--text text--darken-1">TU ENVIAS</h3>
                            </v-col>
                            <v-col cols="6" class="py-1">
                                <v-skeleton-loader class="my-2 mx-auto" width="100%" type="list-item-avatar" v-if="loading === true"/>
                                <v-currency-field
                                    :label="labels.Value"
                                    v-model="form.amount"
                                    name="amount"
                                    filled
                                    :error-messages="errors.amount"
                                    :rules="[rules.required('Value'), rules.minus('Value', form.amount, min, 'El'), rules.maxim('Value', form.amount, max, 'El')]"
                                    :disabled="loading"
                                    @input="clearErrors('amount')"
                                    @keyup="form.amount > 0 ? getCalculate() : null"
                                    v-bind="currency_send"
                                    v-else/>
                            </v-col>
                            <v-col cols="6" class="py-1">
                                <v-skeleton-loader class="my-2 mx-auto" width="100%" type="list-item-avatar" v-if="loading === true"/>
                                <v-select
                                    :label="labels.Currency"
                                    :items="senders"
                                    name="cSend"
                                    v-model="form.cSend"
                                    :error-messages="errors.cSend"
                                    :disabled="loading"
                                    :rules="[rules.req('Currency')]"
                                    @select="clearErrors('cSend')"
                                    filled
                                    v-else>
                                    <template v-slot:selection="{ item }">
                                        <v-flex>
                                            <v-avatar size="24px">
                                                <img :src="'/img/country/' + (item.country ?? '000') + '.png'" :alt="item.country"/>
                                            </v-avatar>
                                            <span class='ml-1'>{{ item.code }}{{ item.bank != null ? " - " + item.bankName : "" }}</span>
                                        </v-flex>
                                    </template>
                                    <template v-slot:item="{ item }">
                                        <v-list-item-avatar>
                                            <img :src="'/img/country/' + (item.country ?? '000') + '.png'" :alt="item.country"/>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title v-html="$vuetify.breakpoint.xsOnly ? item.code : item.code"/>
                                            <v-list-item-subtitle>{{ item.bankName }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="12" class="py-1">
                                <v-skeleton-loader class="my-4 mx-auto" width="100%" height="60px" type="image" style="border: 1px solid #ddd; border-radius: 5px" v-if="loading === true"/>
                                <v-card outlined class="pa-3 bg primary--text" style="border: 1px solid #ddd; border-radius: 5px" v-else>
                                    <span>
                                        <strong><v-icon>mdi-minus-box</v-icon> Costo de Envío:</strong>
                                        {{ form.feeIn ? Number(form.feeIn).toLocaleString("en-US", {minimumFractionDigits: 0, maximumFractionDigits: 2}) : 0 }} {{ form.cSend.code }}
                                    </span>
                                    <br>
                                    <span>
                                        <strong><v-icon>mdi-equal-box</v-icon> Monto a Convertir:</strong>
                                        {{ form.vSend ? Number(form.vSend).toLocaleString("en-US", {minimumFractionDigits: 0, maximumFractionDigits: 2}) : 0 }} {{ form.cSend.code }}
                                    </span>
                                    <br>
                                    <span>
                                        <strong><v-icon>mdi-{{ (form.type === 'sell' ? 'division' : 'close') }}-box</v-icon> Tasa de Cambio:</strong>
                                        {{ form.fx ? Number(form.fx).toLocaleString("en-US", {minimumFractionDigits: 0, maximumFractionDigits: 7}) : 0 }}
                                    </span>
                                    <br>
                                    <span>
                                        <strong><v-icon>mdi-minus-box</v-icon> Costo de Pago:</strong>
                                        {{ form.feeOut ? Number(form.feeOut).toLocaleString("en-US", {minimumFractionDigits: 0, maximumFractionDigits: 2}) : 0 }} {{ form.cReceiver.code }}
                                    </span>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="12" class="pt-3 pb-2">
                                <h3 class="text-center grey--text text--darken-1">TU DESTINATARIO RECIBE</h3>
                            </v-col>
                            <v-col cols="6" class="py-1">
                                <v-skeleton-loader class="my-2 mx-auto" width="100%" type="list-item-avatar" v-if="loading === true"/>
                                <v-currency-field
                                    :label="labels.Value"
                                    v-model="form.vReceiver"
                                    name="vReceiver"
                                    filled
                                    :error-messages="errors.vReceiver"
                                    :rules="[rules.required('Value')]"
                                    :disabled="loading"
                                    @input="clearErrors('vReceiver')"
                                    @keyup="form.vReceiver > 0 ? getCalculate(2) : null"
                                    v-bind="currency_receiver"
                                    v-else/>
                            </v-col>
                            <v-col cols="6" class="py-1">
                                <v-skeleton-loader class="my-2 mx-auto" width="100%" type="list-item-avatar" v-if="loading === true"/>
                                <v-select
                                    :label="labels.Currency"
                                    :items="receivers"
                                    name="cReceiver"
                                    v-model="form.cReceiver"
                                    :error-messages="errors.cReceiver"
                                    :disabled="loading"
                                    :rules="[rules.req('Currency')]"
                                    @select="clearErrors('cReceiver')"
                                    filled
                                    v-else>
                                    <template v-slot:selection="{ item }">
                                        <v-flex>
                                            <v-avatar size="24px">
                                                <img :src="'/img/country/' + (item.country ?? '000') + '.png'" :alt="item.country"/>
                                            </v-avatar>
                                            <span class='ml-1'>{{ item.code }}{{ item.bank != null ? " - " + item.bankName : "" }}</span>
                                        </v-flex>
                                    </template>
                                    <template v-slot:item="{ item }">
                                        <v-list-item-avatar>
                                            <img :src="'/img/country/' + (item.country ?? '000') + '.png'" :alt="item.country"/>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title v-html="$vuetify.breakpoint.xsOnly ? item.code : item.code"/>
                                            <v-list-item-subtitle>{{ item.bankName }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                </v-select>
                            </v-col>
                        </v-row>
                    </v-card>

                    <v-btn color="primary" @click="next(1)">Continuar</v-btn>
                    <v-btn color="tertiary" dark @click="$router.go(-1)">Cancelar</v-btn>
                </v-stepper-content>

                <v-stepper-step :complete="section > 2" step="2">
                    Información de Pago
                    <small>Carga el comprobante o Voucher</small>
                </v-stepper-step>

                <v-stepper-content step="2">
                    <v-card elevation="0" class="pb-3">
                        <v-row justify="center">
                            <v-col cols="12" sm="6">
                                <v-select
                                    v-if="section > 1"
                                    :label="labels.Payment"
                                    :items="payments"
                                    name="Payment"
                                    v-model="form.Payment"
                                    :error-messages="errors.Payment"
                                    :disabled="loading"
                                    :rules="[rules.req('Payment')]"
                                    @select="clearErrors('Payment')"
                                    prepend-icon="mdi-chart-donut"
                                    item-text="text"
                                    item-value="value"
                                    filled>
                                    <template v-slot:selection="{ item }">
                                        <v-flex>
                                            <v-avatar size="28px" color="primary">
                                                <v-icon class="warning--text">{{ item.icon }}</v-icon>
                                            </v-avatar>
                                            <span class='ml-1'>{{ item.text }}</span>
                                        </v-flex>
                                    </template>
                                    <template v-slot:item="{ item }">
                                        <v-list-item-avatar color="primary">
                                            <v-icon class="warning--text">{{ item.icon }}</v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title v-html="item.text"/>
                                        </v-list-item-content>
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="6" v-if="form.cSend.country === 'USA' && form.cSend.code === 'USD' && form.Payment === 'Bank'">
                                <v-text-field
                                    v-if="section > 1"
                                    :label="labels.nameZelle"
                                    v-model="form.nameZelle"
                                    type="text"
                                    name="nameZelle"
                                    hint="Nombre Completo de la Persona que Transfiere el Zelle"
                                    persistent-hint
                                    :error-messages="errors.nameZelle"
                                    :rules="[rules.required('nameZelle'), rules.min('nameZelle', 3, 'El'), rules.max('nameZelle', 100, 'El')]"
                                    :disabled="loading"
                                    prepend-icon="mdi-account-circle"
                                    @input="clearErrors('nameZelle')"
                                    filled
                                />
                            </v-col>
                            <v-col cols="12" sm="6" md="5" v-if="form.Payment === 'Office'">
                                <p class="text-center mb-0">► Tendrá que realizar el pago en efectivo en las cajas de nuestras oficinas.
                                    <br>► Todas las transferencias en nuestras OFICINAS NO TIENEN COSTO.</p>
                            </v-col>
                            <v-col cols="12" sm="6" v-else-if="form.Payment === 'Bank'">
                                <v-file-input
                                    v-if="section > 1"
                                    :label="labels.Voucher"
                                    v-model="form.Voucher"
                                    name="Voucher"
                                    accept="image/*"
                                    :error-messages="errors.Voucher"
                                    :rules="[rules.req('Voucher')]"
                                    :disabled="loading"
                                    prepend-icon="mdi-camera"
                                    @input="clearErrors('Voucher')"
                                    @click:clear="clearVoucher"
                                    show-size counter filled/>
                            </v-col>
                            <v-col cols="12" md="10" v-if="form.Payment === 'Bank'">
                                <p class="text-center error--text mb-0">► Al subir el voucher acepta que esta marcado con el ASUNTO CORRESPONDIENTE.</p>
                            </v-col>
                            <v-col cols="6" sm="5" md="4" lg="3" v-if="imageData !== null">
                                <img :src="imageData" width="100%" alt="voucher" style="border: 1px solid #eee; border-radius: 4px;"/>
                            </v-col>
                        </v-row>
                    </v-card>


                    <v-btn color="primary" @click="next(2)">Continuar</v-btn>
                    <v-btn color="tertiary" dark @click="back(2)">Atras</v-btn>
                </v-stepper-content>

                <v-stepper-step :complete="section > 3" step="3">
                    Datos del Destinatario
                    <small>Ingrese la información solicitada</small>
                </v-stepper-step>

                <v-stepper-content step="3">
                    <v-card elevation="0" class="pb-3">
                        <v-row justify="center">
                            <v-col :cols="(edit ? '10': '12')" sm="10" lg="9">
                                <v-autocomplete
                                    v-if="section > 2"
                                    :label="labels.account"
                                    :items="accounts"
                                    name="account"
                                    placeholder="Registrar nueva cuenta"
                                    v-model="form.account"
                                    :error-messages="errors.account"
                                    :disabled="loading"
                                    clearable
                                    clear-icon="mdi-close-circle"
                                    :rules="[]"
                                    @select="clearErrors('account')"
                                    prepend-icon="mdi-clipboard-text"
                                    item-text="details"
                                    item-value="id"
                                    filled>
                                    <template v-slot:selection="{ item }">
                                        <v-flex>{{ item.details }}</v-flex>
                                    </template>
                                    <template v-slot:item="{ item }">
                                        <v-list-item-avatar color="primary">
                                            <v-icon class="warning--text">mdi-briefcase-account</v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title v-html="item.name + '<br>' + item.bank_details"/>
                                        </v-list-item-content>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="2" sm="3" lg="2" align-self="center" v-if="form.account">
                                <v-btn color="primary" class="px-0" block depressed @click="edit = false">
                                    <v-icon>mdi-pencil</v-icon>
                                    <span v-show="$vuetify.breakpoint.smAndUp">Editar</span>
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="12" :sm="form.bn === 'Nuestras Oficinas' ? 12 : 6">
                                <v-text-field
                                    v-if="section > 2"
                                    :label="labels.name"
                                    v-model="form.name"
                                    type="text"
                                    name="name"
                                    :error-messages="errors.name"
                                    :rules="[rules.required('name'), rules.min('name', 3, 'El'), rules.max('name', 100, 'El')]"
                                    :disabled="loading"
                                    :readonly="edit"
                                    prepend-icon="mdi-account-circle"
                                    @input="clearErrors('name')"
                                    filled
                                />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-autocomplete
                                    v-if="section > 2"
                                    :label="labels.bank"
                                    :items="banks"
                                    name="bank"
                                    v-model="form.bank"
                                    :error-messages="errors.bank"
                                    :disabled="loading"
                                    :readonly="edit"
                                    :rules="[rules.required('bank')]"
                                    @select="clearErrors('bank')"
                                    prepend-icon="mdi-domain"
                                    item-text="name"
                                    item-value="code"
                                    filled
                                />
                            </v-col>
                            <v-col cols="12" sm="6" v-if="form.bn === 'Nuestras Oficinas'">
                                <v-autocomplete
                                    v-if="section > 2"
                                    :label="labels.branch"
                                    :items="branches"
                                    name="branch"
                                    v-model="form.branch"
                                    :error-messages="errors.branch"
                                    :disabled="loading"
                                    :readonly="edit"
                                    :rules="[rules.required('branch')]"
                                    @select="clearErrors('branch')"
                                    prepend-icon="mdi-store"
                                    item-text="name"
                                    item-value="id"
                                    filled
                                />
                            </v-col>
                            <v-col cols="12" sm="6" v-if="form.cReceiver.country !== 'BRA' && form.cReceiver.country !== 'USA' && form.cReceiver.code !== 'USDT'">
                                <v-select
                                    v-if="section > 2"
                                    :label="labels.td"
                                    :items="td"
                                    name="td"
                                    v-model="form.td"
                                    :error-messages="errors.td"
                                    :disabled="loading"
                                    :readonly="edit"
                                    :rules="[rules.required('td')]"
                                    @select="clearErrors('td')"
                                    prepend-icon="mdi-clipboard-text"
                                    item-text="name"
                                    item-value="value"
                                    filled>
                                    <template v-slot:selection="{ item }">
                                        <v-flex>
                                            <v-avatar size="28px" color="primary">
                                                <span class="warning--text subtitle-2 text-center" style="width: 100%">{{ item.value }}</span>
                                            </v-avatar>
                                            <span class='ml-1'>{{ item.name }}</span>
                                        </v-flex>
                                    </template>
                                    <template v-slot:item="{ item }">
                                        <v-list-item-avatar color="primary">
                                            <span class="warning--text subtitle-1 text-center" style="width: 100%">
                                                <strong>{{ item.value }}</strong>
                                            </span>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title v-html="item.name"/>
                                        </v-list-item-content>
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" v-if="section > 2 && form.country !== 'BRA' && form.country !== 'USA' && form.cReceiver.code !== 'USDT'">
                                <v-text-field
                                    v-if="form.cReceiver.country === 'CHL' && (form.td === 'CI' || form.td === 'CE')"
                                    :label="labels.nd"
                                    v-model="form.nd"
                                    type="text"
                                    name="nd"
                                    :error-messages="errors.nd"
                                    :rules="[rules.required('nd'), rules.equal('nd', 10, 9, 'El')]"
                                    :disabled="loading"
                                    :readonly="edit"
                                    prepend-icon="mdi-ballot"
                                    @input="clearErrors('nd')"
                                    v-mask="rut"
                                    filled
                                />
                                <v-text-field
                                    v-if="form.td === 'PAS'"
                                    :label="labels.nd"
                                    v-model="form.nd"
                                    type="text"
                                    name="nd"
                                    :error-messages="errors.nd"
                                    :rules="[rules.required('nd'), rules.min('nd', 5, 'El'), rules.max('nd', 20, 'El')]"
                                    :disabled="loading"
                                    :readonly="edit"
                                    prepend-icon="mdi-ballot"
                                    @input="clearErrors('nd')"
                                    filled
                                />
                                <v-text-field
                                    :label="labels.nd"
                                    v-model="form.nd"
                                    type="number"
                                    name="nd"
                                    :error-messages="errors.nd"
                                    :rules="[rules.required('nd'), rules.min('nd', 5, 'El'), rules.max('nd', 12, 'El')]"
                                    :disabled="loading"
                                    :readonly="edit"
                                    prepend-icon="mdi-ballot"
                                    @input="clearErrors('nd')"
                                    filled
                                />
                            </v-col>
                            <v-col cols="12" sm="6" v-if="form.cReceiver.country !== 'USA' && form.bn !== 'Nuestras Oficinas'">
                                <v-select
                                    v-if="section > 2"
                                    :label="labels.tc"
                                    :items="tc"
                                    name="tc"
                                    v-model="form.tc"
                                    :error-messages="errors.tc"
                                    :disabled="loading"
                                    :readonly="edit"
                                    :rules="[rules.required('tc')]"
                                    @select="clearErrors('tc')"
                                    prepend-icon="mdi-bank-transfer"
                                    item-text="name"
                                    item-value="value"
                                    filled>
                                    <template v-slot:selection="{ item }">
                                        <v-flex>
                                            <v-avatar size="28px" color="primary">
                                                <v-icon class="warning--text">mdi-account-convert</v-icon>
                                            </v-avatar>
                                            <span class='ml-1'>{{ item.name }}</span>
                                        </v-flex>
                                    </template>
                                    <template v-slot:item="{ item }">
                                        <v-list-item-avatar color="primary">
                                            <v-icon class="warning--text">mdi-account-convert</v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title v-html="item.name"/>
                                        </v-list-item-content>
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" v-if="form.cReceiver.country === 'VEN' && form.bn !== 'Nuestras Oficinas'">
                                <v-text-field
                                    v-if="section > 2"
                                    :label="labels.nc"
                                    v-model="form.nc"
                                    type="tel"
                                    name="nc"
                                    :prefix="form.bank"
                                    :error-messages="errors.nc"
                                    :rules="[rules.required('nc'), rules.minT('nc', 19, 20, 'El'), rules.maxT('nc', 19, 20, 'El')]"
                                    :disabled="loading"
                                    :readonly="edit"
                                    prepend-icon="mdi-dialpad"
                                    @input="clearErrors('nc')"
                                    v-mask="mask"
                                    filled
                                />
                            </v-col>
                            <v-col cols="12" sm="6" v-else-if="form.bn !== 'Nuestras Oficinas'">
                                <v-text-field
                                    v-if="section > 2"
                                    :label="form.cReceiver.country === 'BRA' && form.tc !== null ? form.tc + ' Afiliado a Pix' : (form.cReceiver.country === 'USA' ? form.tc + ' Zelle' : labels.nc)"
                                    v-model="form.nc"
                                    :type="form.tc === 'Email' ? 'email' : 'tel'"
                                    name="nc"
                                    :error-messages="errors.nc"
                                    :rules="[rules.required('nc'), rules.min('nc', 5, 'El'), rules.max('nc', 50, 'El')]"
                                    :disabled="loading"
                                    :readonly="edit"
                                    prepend-icon="mdi-dialpad"
                                    @input="clearErrors('nc')"
                                    filled
                                />
                            </v-col>
                            <v-col cols="12" sm="6" v-else>
                                <v-text-field
                                    v-if="section > 2"
                                    :label="labels.phone"
                                    v-model="form.phone"
                                    type="tel"
                                    name="phone"
                                    :error-messages="errors.phone"
                                    :rules="[rules.required('phone')]"
                                    :disabled="loading"
                                    :readonly="edit"
                                    prepend-icon="mdi-dialpad"
                                    @input="clearErrors('phone')"
                                    filled
                                />
                            </v-col>
                            <v-col cols="12" sm="6" v-if="form.cReceiver.code === 'USDT'">
                                <v-file-input
                                    v-if="section > 2 && (edit === false || form.account === null)"
                                    :label="labels.img"
                                    v-model="form.img"
                                    name="img"
                                    accept="image/*"
                                    :error-messages="errors.img"
                                    :rules="[rules.req('img')]"
                                    :disabled="loading"
                                    :readonly="edit"
                                    prepend-icon="mdi-image"
                                    @input="clearErrors('img')"
                                    @click:clear="form.img = null"
                                    show-size
                                    filled
                                />
                            </v-col>
                        </v-row>
                    </v-card>

                    <v-btn color="primary" @click="next(3)">Continuar</v-btn>
                    <v-btn color="tertiary" dark @click="back(3)">Atras</v-btn>
                </v-stepper-content>

                <v-stepper-step step="4">
                    Resumen
                    <small>Confirme la Información</small>
                </v-stepper-step>

                <v-stepper-content step="4">
                    <v-card elevation="0" class="pb-3">
                        <v-row justify="center">
                            <v-col cols="12" sm="10" class="text-center">
                                <v-simple-table dense>
                                    <template v-slot:default>
                                        <thead>
                                        <tr>
                                            <th colspan="2">
                                                <h3 class="text-center">
                                                    <strong>Información de Envío</strong>
                                                </h3>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td class="text-right" width="40%">Nombres</td>
                                            <td class="text-left" width="60%">{{form.name}}</td>
                                        </tr>
                                        <tr v-if="form.cReceiver.country !== 'BRA' && form.cReceiver.country !== 'USA' && form.cReceiver.code !== 'USDT'">
                                            <td class="text-right">Documento</td>
                                            <td class="text-left">{{form.td}} - {{form.nd}}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-right">Banco</td>
                                            <td class="text-left">{{form.bn}}</td>
                                        </tr>
                                        <tr v-if="form.bn !== 'Nuestras Oficinas'">
                                            <td class="text-right">Cuenta</td>
                                            <td class="text-left" style="overflow-wrap: anywhere;">{{form.tc}}<br>{{(form.cReceiver.country === 'VEN' ? form.bank + ' ' : '') + form.nc}}</td>
                                        </tr>
                                        <tr v-else>
                                            <td class="text-right">Sucursal</td>
                                            <td class="text-left">{{form.br}}</td>
                                        </tr>
                                        <tr v-if="form.bn === 'Nuestras Oficinas'">
                                            <td class="text-right">Telefono</td>
                                            <td class="text-left">{{form.phone}}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-right">Valor Depositado</td>
                                            <td class="text-left">{{Number(form.amount).toLocaleString("en-US")}} {{form.cSend.code}}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-right">Comisión Origen</td>
                                            <td class="text-left">{{Number(form.feeIn).toLocaleString("en-US")}} {{form.cSend.code}}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-right">Valor Enviado</td>
                                            <td class="text-left">{{Number(form.vSend).toLocaleString("en-US")}} {{form.cSend.code}}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-right">Tasa de Cambio</td>
                                            <td class="text-left">{{Number(form.fx).toLocaleString("en-US", {minimumFractionDigits: 0, maximumFractionDigits: 6})}}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-right">Comisión Destino</td>
                                            <td class="text-left">{{Number(form.feeOut).toLocaleString("en-US")}} {{form.cReceiver.code}}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-right">Valor Destino</td>
                                            <td class="text-left">{{Number(form.vReceiver).toLocaleString("en-US")}} {{form.cReceiver.code}}</td>
                                        </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                                <v-btn @click="back(4)" depressed class="my-4" color="primary" style="display:inline-grid;white-space:normal;">
                                    <v-icon>mdi-pencil</v-icon> Corregir
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card>

                    <v-btn color="success" :loading="loading" :disabled="loading || !valid" @click="submit">Enviar</v-btn>
                    <v-btn color="tertiary" dark @click="back(4)">Atras</v-btn>
                </v-stepper-content>
            </v-form>
        </v-stepper>
    </v-container>
</template>

<script>
import axios from 'axios';
import Form from "../../helpers/form";
import { mask } from 'vue-the-mask';

export default {
    name: "Single",
    props: ['user'],
    mixins: [Form],
    directives: { mask },
    data: () => ({
        loading: true,
        section: 1,
        labels: {
            Value: 'Valor',
            Currency: 'Moneda',
            Payment: 'Forma de Pago',
            nameZelle: 'Nombre Titular de Zelle',
            Voucher: 'Foto del Voucher',
            account: 'Cuenta Bancaria',
            name: 'Nombre del Beneficiario',
            td: 'Tipo de Documento',
            nd: 'Número de Documento',
            bank: 'Banco del Beneficiario',
            branch: 'Oficina de Pago',
            tc: 'Tipo de Cuenta',
            nc: 'Número de Cuenta',
            phone: 'Telefono del Beneficiario',
            img: 'Imagen'
        },
        form: {
            amount: 0,
            feeIn: 0,
            vSend: 0,
            cSend: '',
            type: '',
            fx: 0,
            feeOut: 0,
            vReceiver: 0,
            cReceiver: '',

            Payment: null,
            nameZelle: null,
            Voucher: null,

            account: null,
            name: null,
            td: null,
            nd: null,
            bank: null,
            branch: null,
            bn: null,
            br: null,
            tc: null,
            nc: null,
            phone: null,
            img: null
        },
        td: [],
        tc: [],
        edit: false,
        rates: [],
        fees: {},
        limits: {},
        senders: [],
        receivers: [],
        payments: [],
        accounts: [],
        banks: [],
        branches: [],
        offices: [],
        min: null,
        max: null,
        imageData: null,
        currency_send: {
            locale: 'en-US',
            decimalLength: 2,
            autoDecimalMode: false,
            min: null,
            max: null,
            defaultValue: 0,
            valueAsInteger: false,
            allowNegative: false
        },
        currency_receiver: {
            locale: 'en-US',
            decimalLength: 2,
            autoDecimalMode: false,
            min: null,
            max: null,
            defaultValue: 0,
            valueAsInteger: false,
            allowNegative: false
        },
        mask: '#### #### #### ####',
        rut: '########-X'
    }),
    mounted() {
        this.getData();
    },
    watch: {
        'form.cSend'() {
            this.getParams();
            this.getReceivers();
            this.getPayments(this.form.cSend.country)
        },
        'form.cReceiver'() {
            this.getSenders()
            this.getCalculate();
            this.getMyAccounts(this.form.cReceiver.country);
            this.getBanks(this.form.cReceiver.country);
            this.getTypeDoc(this.form.cReceiver.country);
            this.getTypeAcc(this.form.cReceiver.country);
            if (this.form.cReceiver.country === 'USA') {
                this.form.tc = 'Email';
            } else if (this.form.cReceiver.code === 'USDT') {
                this.form.tc = 'TRC20';
            } else {
                this.form.tc = null;
            }
        },
        'form.Payment'() {
            if (this.form.Payment) {
                if (this.form.Payment !== 'Bank') {
                    this.form.Voucher = null;
                    this.imageData = null;
                }
            }
        },
        'form.Voucher'() {
            if (this.form.Voucher) {
                this.getVoucher();
            }
        },
        'form.account'() {
            if (this.form.account) {
                this.account();
                this.edit = true;
            } else {
                this.form.account = null;
                this.form.name = null;
                this.form.td = null;
                this.form.nd = null;
                this.form.bank = null;
                this.form.branch = null;
                this.form.tc = null;
                this.form.nc = null;
                this.form.phone = null;
                this.edit = false;
                this.$refs.form.resetValidation();
            }
        },
        'form.nd'() {
            if (this.form.td === 'PAS') {
                this.form.nd = (this.form.nd).toUpperCase();
            }
        },
        'form.bank'() {
            if (this.form.bank) {
                this.getBank();
            } else {
                this.form.bn = null;
            }
        },
        'form.branch'() {
            if (this.form.branch) {
                this.getBranch();
            } else {
                this.form.br = null;
            }
        }
    },
    methods: {
        back(n) {
            this.section = n - 1;
        },
        next(n) {
            if (this.$refs.form.validate()) {
                this.section = n + 1;
            }
        },
        getData() {
            clearTimeout(this.timeout);
            axios.get('/api/currencies/all').then((res) => {
                this.rates = res.data.rates;
                this.fees = res.data.fees;
                this.limits = res.data.limits;
            }).catch(err => {
                this.handleErrors(err.response.data.errors);
            }).then(() => {
                this.getSenders();
                this.loading = false;
            });
            this.timeout = setTimeout(this.getData, 1200000);
        },
        getSenders() {
            const rates = this.rates;
            const sender = this.form.cSend;
            const receiver = this.form.cReceiver;
            let senders = [];
            for (let i = 0; i < rates.length; i++) {
                if (rates[i].country_send !== receiver.country && (rates[i].country_send === this.user.country || rates[i].country_send === null)) {
                    const a = {
                        country: rates[i].country_send,
                        code: rates[i].currency_send,
                        digits: rates[i].currency_send_dd,
                        bank: rates[i].bank_send,
                        bankName: rates[i].bank_send_name
                    }
                    let v = (JSON.stringify(senders)).includes(JSON.stringify(a));
                    if (v === false) {
                        senders.push(a);
                    }
                }
            }
            this.senders = senders;
            if (sender.length === 0) {
                this.form.cSend = senders[0];
            }
            this.getParams();
        },
        getParams() {
            let limits = this.limits;
            let min = limits['min'];
            let max = limits['max'];
            let currency = this.form.cSend.code;

            for (let i = 0; i < min.length; i++) {
                if (min[i].data.currency === currency) {
                    this.min = parseInt(min[i].data.value);
                }
            }

            for (let i = 0; i < max.length; i++) {
                if (max[i].data.currency === currency) {
                    this.max = parseInt(max[i].data.value);
                }
            }
        },
        getReceivers() {
            const rates = this.rates;
            const sender = this.form.cSend;
            const receiver = this.form.cReceiver;
            let receivers = [];
            for (let i = 0; i < rates.length; i++) {
                if (sender.country === rates[i].country_send &&
                    sender.code === rates[i].currency_send &&
                    sender.bank === rates[i].bank_send) {
                    const a = {
                        country: rates[i].country_receiver,
                        code: rates[i].currency_receiver,
                        digits: rates[i].currency_receiver_dd,
                        bank: rates[i].bank_receiver,
                        bankName: rates[i].bank_receiver_name
                    }
                    let v = (JSON.stringify(receivers)).includes(JSON.stringify(a));
                    if (v === false) {
                        receivers.push(a);
                    }
                }
            }
            this.receivers = receivers;
            if (receiver.length === 0 || sender === receiver) {
                this.form.cReceiver = receivers[0];
            }
            this.getSenders();
            this.getCalculate();
        },
        getCalculate(n) {
            let feeIn = this.form.feeIn;
            let feeOut = this.form.feeOut;
            let type = null;
            let rate = 0;
            let value = this.form.amount;
            let send = 0;
            let result = this.form.vReceiver;
            const rates = this.rates;
            const fees = this.fees;
            const sender = this.form.cSend;
            const receiver = this.form.cReceiver;
            for (let i = 0; i < rates.length; i++) {
                if (sender.country === rates[i].country_send &&
                    sender.code === rates[i].currency_send &&
                    sender.bank === rates[i].bank_send &&
                    receiver.country === rates[i].country_receiver &&
                    receiver.code === rates[i].currency_receiver &&
                    receiver.bank === rates[i].bank_receiver) {
                    type = rates[i].type;
                    rate = rates[i].value;
                }
            }
            if (n === 2) {
                feeOut = 0;
                let b1 = false;
                let b2 = false;
                let b3 = false;
                for (let i = 0; i < fees.length; i++) {
                    if (fees[i].category === 'Out' && parseFloat(fees[i].value) > 0) {
                        if (result >= fees[i].range_min && result <= fees[i].range_max) {
                            if (fees[i].currency === receiver.code || (b1 === false && fees[i].currency === null)) {
                                if (fees[i].currency === receiver.code) {
                                    b1 = true;
                                }
                                if (fees[i].country_receiver === receiver.country || (b2 === false && fees[i].country_receiver === null)) {
                                    if (fees[i].country_receiver === receiver.country) {
                                        b2 = true;
                                    }
                                    if (fees[i].country_send === sender.country || (b3 === false && fees[i].country_send === null)) {
                                        if (fees[i].country_send === sender.country) {
                                            b3 = true;
                                        }
                                        if (fees[i].type === '%' && fees[i].value > 0) {
                                            feeOut = (parseFloat(result) * (1 + (parseFloat(fees[i].value) / 100))) - parseFloat(result);
                                        } else if (fees[i].type === '$') {
                                            feeOut = parseFloat(fees[i].value);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                result = parseFloat(result) + feeOut;
                send = type === 'sell' ? result * parseFloat(rate) : result / parseFloat(rate);
                feeIn = 0;
                let c1 = false;
                let c2 = false;
                let c3 = false;
                for (let i = 0; i < fees.length; i++) {
                    if (fees[i].category === 'In' && parseFloat(fees[i].value) > 0) {
                        if (send >= fees[i].range_min && send <= fees[i].range_max) {
                            if (fees[i].currency === sender.code || (c1 === false && fees[i].currency === null)) {
                                if (fees[i].currency === sender.code) {
                                    c1 = true;
                                }
                                if (fees[i].country_send === sender.country || (c2 === false && fees[i].country_send === null)) {
                                    if (fees[i].country_send === sender.country) {
                                        c2 = true;
                                    }
                                    if (fees[i].country_receiver === receiver.country || (c3 === false && fees[i].country_receiver === null)) {
                                        if (fees[i].country_receiver === receiver.country) {
                                            c3 = true;
                                        }
                                        if (fees[i].type === '%' && parseFloat(fees[i].value) > 0) {
                                            feeIn = (parseFloat(send) * (1 + (parseFloat(fees[i].value) / 100))) - parseFloat(send);
                                        } else if (fees[i].type === '$') {
                                            feeIn = parseFloat(fees[i].value);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                this.form.amount = parseFloat(send) + feeIn;
            } else {
                feeIn = 0;
                let c1 = false;
                let c2 = false;
                let c3 = false;
                for (let i = 0; i < fees.length; i++) {
                    if (fees[i].category === 'In' && parseFloat(fees[i].value) > 0) {
                        if (value >= fees[i].range_min && value <= fees[i].range_max) {
                            if (fees[i].currency === sender.code || (c1 === false && fees[i].currency === null)) {
                                if (fees[i].currency === sender.code) {
                                    c1 = true;
                                }
                                if (fees[i].country_send === sender.country || (c2 === false && fees[i].country_send === null)) {
                                    if (fees[i].country_send === sender.country) {
                                        c2 = true;
                                    }
                                    if (fees[i].country_receiver === receiver.country || (c3 === false && fees[i].country_receiver === null)) {
                                        if (fees[i].country_receiver === receiver.country) {
                                            c3 = true;
                                        }
                                        if (fees[i].type === '%') {
                                            feeIn = parseFloat(value) - (parseFloat(value) / (1 + (parseFloat(fees[i].value) / 100)));
                                        } else if (fees[i].type === '$') {
                                            feeIn = parseFloat(fees[i].value);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                send = parseFloat(value) - feeIn;
                result = type === 'sell' ? send / parseFloat(rate) : send * parseFloat(rate);
                feeOut = 0;
                let b1 = false;
                let b2 = false;
                let b3 = false;
                for (let i = 0; i < fees.length; i++) {
                    if (fees[i].category === 'Out' && parseFloat(fees[i].value) > 0) {
                        if (result >= fees[i].range_min && result <= fees[i].range_max) {
                            if (fees[i].currency === receiver.code || (b1 === false && fees[i].currency === null)) {
                                if (fees[i].currency === receiver.code) {
                                    b1 = true;
                                }
                                if (fees[i].country_receiver === receiver.country || (b2 === false && fees[i].country_receiver === null)) {
                                    if (fees[i].country_receiver === receiver.country) {
                                        b2 = true;
                                    }
                                    if (fees[i].country_send === sender.country || (b3 === false && fees[i].country_send === null)) {
                                        if (fees[i].country_send === sender.country) {
                                            b3 = true;
                                        }
                                        if (fees[i].type === '%' && fees[i].value > 0) {
                                            feeOut = parseFloat(result) - (parseFloat(result) / (1 + (parseFloat(fees[i].value) / 100)));
                                        } else if (fees[i].type === '$') {
                                            feeOut = parseFloat(fees[i].value);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                this.form.vReceiver = parseFloat(result) - feeOut;
            }
            this.form.feeIn = feeIn.toFixed(sender.digits);
            this.form.vSend = send;
            this.form.type = type;
            this.form.fx = rate;
            this.form.feeOut = feeOut.toFixed(receiver.digits);
        },
        getTypeDoc(c) {
            if (c === 'MEX' || c === 'USA') {
                this.td = [
                    { name: 'Licencia de Conducir', value: 'LIC' },
                    { name: 'Pasaporte', value: 'PAS' }
                ]
            } else if (c === 'PER') {
                this.td = [
                    { name: 'Documento Nacional de Identidad', value: 'DNI' },
                    { name: 'Carnet de Extranjeria', value: 'CE' },
                    { name: 'Permiso Temporal de Permanencia', value: 'PTP' },
                    { name: 'Pasaporte', value: 'PAS' }
                ]
            } else if (c === 'COL') {
                this.td = [
                    { name: 'Cedula de Ciudadania', value: 'CC' },
                    { name: 'Cedula de Extranjeria', value: 'CE' },
                    { name: 'Número de Identificación Tributaria', value: 'NIT' },
                    { name: 'Permiso por Protección Temporal', value: 'PPT' },
                    { name: 'Pasaporte', value: 'PAS' }
                ]
            } else if (c === 'VEN') {
                this.td = [
                    { name: 'Cedula de Identidad', value: 'V' },
                    { name: 'Carnet de Extranjeria', value: 'E' },
                    { name: 'RIF', value: 'J' },
                    { name: 'Gubernamental', value: 'G' },
                    { name: 'Firma Personal', value: 'M' },
                    { name: 'Pasaporte', value: 'PAS' }
                ]
            } else if (c === 'CHL') {
                this.td = [
                    {name: 'Rol Único Tributario', value: 'RUT'},
                    {name: 'Rol Único Nacional', value: 'RUN'},
                    {name: 'Cedula de Identidad', value: 'CI'},
                    {name: 'Cedula de Extranjeria', value: 'CE'},
                    {name: 'Licencia de Conducir', value: 'LIC'},
                    {name: 'Pasaporte', value: 'PAS'}
                ]
            } else {
                this.td = [
                    { name: 'Cedula de Identidad', value: 'CI' },
                    { name: 'Cedula de Extranjeria', value: 'CE' },
                    { name: 'Licencia de Conducir', value: 'LIC' },
                    { name: 'Pasaporte', value: 'PAS' }
                ]
            }
        },
        getTypeAcc(c) {
            if (c === 'CHL') {
                this.tc = [
                    { name: 'Cuenta de Ahorros', value: 'Ahorros' },
                    { name: 'Cuenta Corriente', value: 'Corriente' },
                    { name: 'Cuenta Vista', value: 'Vista' },
                    { name: 'Cuenta RUT', value: 'RUT' }
                ]
            } else if (c === 'BRA') {
                this.tc = [
                    { name: 'Celular Afiliado a Pix', value: 'Celular' },
                    { name: 'Número de Documento', value: 'CPF/CNPJ' },
                    { name: 'Email Afiliado a Pix', value: 'Email' },
                    { name: 'Clave Aleatoria de Pix', value: 'Clave' }
                ]
            } else if (c === 'null' || c === null) {
                this.tc = [
                    { name: 'Red Tron (TRC20)', value: 'TRC20' },
                ]
            } else {
                this.tc = [
                    { name: 'Cuenta de Ahorros', value: 'Ahorros' },
                    { name: 'Cuenta Corriente', value: 'Corriente' }
                ]
            }
        },
        getPayments() {
            axios.get('/api/offices').then((res) => {
                this.offices = res.data.offices;
                this.payments = [
                    { text: 'Deposito/Transferencia', value: 'Bank', icon: 'mdi-bank-transfer' }
                ];
                if (res.data.c > 0) {
                    this.payments.push({ text: 'Efectivo', value: 'Office', icon: 'mdi-currency-usd' });
                }

                this.form.Payment = (this.payments)[0].value;
            }).catch(err => {
                this.handleErrors(err.response.data.errors);
            });
        },
        getVoucher() {
            const input = this.form.Voucher;

            if (input) {
                const reader = new FileReader;
                reader.onload = e => {
                    this.imageData = e.target.result;
                };
                reader.readAsDataURL(input);
            }
        },
        clearVoucher() {
            this.form.Voucher = null;
            this.imageData = null;
        },
        getMyAccounts(country) {
            if (country === 'null' || country === null) {
                country = '000';
            }
            axios.get('/api/receivers/v/' + country).then((res) => {
                let accounts = res.data.items;
                let items = [];

                if (this.form.cReceiver.bank) {
                    for (let i = 0; i < accounts.length; i++) {
                        if (accounts[i].bank === this.form.cReceiver.bank && (accounts[i].currency === this.form.cReceiver.code || accounts[i].currency === null)) {
                            items.push(accounts[i]);
                        }
                    }
                } else {
                    for (let i = 0; i < accounts.length; i++) {
                        if (accounts[i].currency === this.form.cReceiver.code || accounts[i].currency === null) {
                            items.push(accounts[i]);
                        }
                    }
                }
                this.accounts = items;
            }).catch(err => {
                this.handleErrors(err.response.data.errors);
            });
        },
        account() {
            const accounts = this.accounts;

            for (let i = 0; i < accounts.length; i++) {
                if (accounts[i].id === this.form.account) {
                    this.form.name = accounts[i].name;
                    this.form.td = accounts[i].td;
                    this.form.nd = accounts[i].nd;
                    this.form.bank = accounts[i].bank_code;
                    this.form.branch = accounts[i].branch;
                    this.form.bn = accounts[i].bank_name;
                    this.form.br = accounts[i].branch_name;
                    this.form.tc = accounts[i].tc;
                    this.form.nc = this.form.cReceiver.country === 'VEN' && accounts[i].nc ? (accounts[i].nc).replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim() : accounts[i].nc;
                    this.form.phone = accounts[i].phone;
                }
            }
        },
        getBanks(country) {
            if (country === 'null' || country === null) {
                country = '000';
            }
            axios.get('/api/banks/' + country).then((res) => {
                if (this.form.cReceiver.bank !== null) {
                    let banks = res.data.banks;
                    let items = [];

                    for (let i = 0; i < banks.length; i++) {
                        if (banks[i].code === this.form.cReceiver.bank) {
                            items.push(banks[i]);
                        }
                    }
                    this.banks = items;
                } else {
                    this.banks = res.data.banks;
                }
                this.branches = res.data.branches;
                this.form.bank = (this.banks)[0].code;
            });
        },
        getBank() {
            const banks = this.banks;

            for (let i = 0; i < banks.length; i++) {
                if (banks[i].code === this.form.bank) {
                    if (banks[i].name === 'Nuestras Oficinas') {
                        this.form.tc = null;
                        this.form.nc = null;
                    } else {
                        this.form.branch = null;
                        this.form.phone = null;
                    }
                    this.form.bn = banks[i].name;
                }
            }
        },
        getBranch() {
            const branches = this.branches;

            for (let i = 0; i < branches.length; i++) {
                if (branches[i].code === this.form.branch) {
                    this.form.br = branches[i].name;
                }
            }
        },
        submit() {
            if (this.$refs.form.validate()) {
                this.loading = true;

                let formData = new FormData();

                formData.append('country', this.form.cSend.country);
                formData.append('payment',  this.form.Payment);
                formData.append('nameZelle',  this.form.nameZelle);
                formData.append('voucher', this.form.Voucher);
                formData.append('amount',  this.form.amount);
                formData.append('currency',  this.form.cSend.code);
                formData.append('Qty',  1);
                formData.append('fee',  this.form.feeIn);

                formData.append('account_1',  this.form.account ? this.form.account : 0);
                formData.append('name_1',  this.form.name);
                formData.append('td_1',  this.form.td);
                formData.append('nd_1',  this.form.nd);
                formData.append('bank_1',  this.form.bank);
                formData.append('branch_1',  this.form.branch);
                formData.append('tc_1',  this.form.tc);
                formData.append('nc_1',  (this.form.nc).replace(/ /g, ''));
                formData.append('phone_1',  this.form.phone);
                formData.append('img_1', this.form.img);
                formData.append('amount_1',  this.form.vSend);
                formData.append('quotes_1',  JSON.stringify(this.form));
                formData.append('fee_1',  this.form.feeOut);
                formData.append('fx_1',  this.form.fx);
                formData.append('convert_1',  this.form.vReceiver);
                formData.append('cConvert_1',  this.form.cReceiver.code);
                formData.append('destiny_1', this.form.cReceiver.country);

                axios.post('/api/request/save', formData, {
                    headers: {'Content-Type': 'multipart/form-data'}
                }).then(res => {
                    this.$toast.success(res.data.status, { icon: 'mdi-check-circle' });
                    this.$emit('confirm');
                }).catch(err => {
                    this.handleErrors(err.response.data.errors);
                }).then(() => {
                    this.loading = false;
                })
            }
        }
    },
    destroyed() {
        clearTimeout(this.timeout);
    }
}
</script>

<style scoped>

</style>
